import { VueRenderer } from '@tiptap/vue-2'
import MentionList from './MentionList'
import tippy from 'tippy.js'

export default (items) => ({
  HTMLAttributes: {
    class: 'mention'
  },
  suggestion: {
    items: ({ query }) => {
      query = query.replaceAll('_', ' ')
      return items
        .filter(item => item.label.toLowerCase().startsWith(query.toLowerCase()))
    },
    render: () => {
      let component
      let popup

      return {
        onStart: props => {
          component = new VueRenderer(MentionList, {
            parent: this,
            propsData: props
          })

          popup = tippy('body', {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            content: component.element,
            // true because popup is created on '@' detected
            showOnCreate: true,
            interactive: true,
            trigger: 'manual',
            placement: 'bottom-start'
          })
        },
        onUpdate(props) {
          component.updateProps(props)

          popup[0].setProps({
            getReferenceClientRect: props.clientRect
          })
        },
        onKeyDown(props) {
          if (component.ref) {
            return component.ref.onKeyDown(props)
          }
        },
        onExit() {
          popup[0].destroy()
          component.destroy()
        }
      }
    }
  }
})
